import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-address",
  "use": "icon-address-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-address\"><defs><style type=\"text/css\"></style></defs><path d=\"M512 511c-91.9 0-166.4-75.3-166.4-168S420.1 175 512 175s166.4 75.3 166.4 168S603.9 511 512 511z m0-448c-153.2 0-277.3 125.3-277.3 280S512 959 512 959s277.3-461.3 277.3-616S665.2 63 512 63z\" p-id=\"2024\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol